import React from 'react'
const MainDiv = (props) => {
  return (
    <div style={{width:'100%',height:'auto',display:'flex',flexDirection:'column',margin:'auto',justifyContent:'center',padding:'0px'}}>
      {props?.children}
    </div>
  )
}
 
export default (MainDiv)